import { RootState } from 'APP/Store/CreateStore'

export const selectToasts = (state: RootState) => state.toast?.toasts || []

export const selectActiveToast = (state: RootState) => state.toast?.toasts?.[0] || null
